// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import React from 'react'
import { Row, Col } from 'reactstrap'

export default {
  heading: 'Protection',
  items: [{
    label: 'How do I renew my protection service?',
    details: (
      <>
        {'Contact Customer Support: '}
        <a
          href='mailto:customersupport@comsearch.com'
          rel='noopener noreferrer'
          target='_blank'>
          {'customersupport@comsearch.com'}
        </a>
      </>
    ),
  }, {
    label: 'Where can I send PCN notices I receive to have them verified?',
    details: (
      <a
        href='mailto:epcn@comsearch.com'
        rel='noopener noreferrer'
        target='_blank'>
        {'EPCN@comsearch.com'}
      </a>
    ),
  }, {
    label: 'Who can I contact regarding Protection service questions?',
    details: (
      <Row>
        <Col sm={6}>
          <div className={'display-flex flex-direction-column margin-bottom-1'}>
            <strong>{'Billing/Data Contact:'}</strong>
            <span>{'Meaghan Stewart'}</span>
            <a href='tel:1-703-726-5634'>
              {'(703)726-5634'}
            </a>
            <a
              href='mailto:mstewart@comsearch.com'
              rel='noopener noreferrer'
              target='_blank'>
              {'mstewart@comsearch.com'}
            </a>
          </div>
          <div className={'display-flex flex-direction-column margin-bottom-1'}>
            <strong>{'Technical Information:'}</strong>
            <span>{'David Meyer'}</span>
            <a href='tel:1-703-726-5656'>
              {'(703)726-5656'}
            </a>
            <a
              href={'mailto:dmeyer@comsearch.com'}
              rel={'noopener noreferrer'}
              target={'_blank'}>
              {'dmeyer@comsearch.com'}
            </a>
          </div>
        </Col>
        <Col sm={6}>
          <div className={'display-flex flex-direction-column margin-bottom-1'}>
            <strong>{'Other Service Inquiries:'}</strong>
            <span>{'Denise Finney'}</span>
            <a href='tel:1-703-726-5650'>
              {'(703)726-5650'}
            </a>
            <a
              href='mailto:dfinney@comsearch.com'
              rel='noopener noreferrer'
              target='_blank'>
              {'dfinney@comsearch.com'}
            </a>
          </div>
        </Col>
      </Row>
    ),
  }, {
    label: 'How long does it take for a case to be resolved?',
    details: 'A case can be resolved in a few days or in several months, it all depends on the clearance proposed by the coordinator.',
  }, {
    label: 'What do I need to do when a case is reported to me? (Protected customers)',
    details: `Nothing! The case data is provided for your information. We will contact
              you by email and/or phone if additional information is needed or if direct action is required.`,
  }],
}
